import { styled } from '@mui/material'

export const Heading = styled('div')`
  display: flex;
  font-weight: 700;
  color: #4f4848;
  border-bottom: 2px solid #c93c41;
  padding-bottom: 8px;
`
